import { TypeServiceEnum } from '../types';

export interface SelectedServiceRef {
	serviceId: string;
	saleOrderId: string;
	serviceType: TypeServiceEnum;
	reference: string;
	agencyId?: number;
	tariffProviderFantasyName?: string;
}

const STORAGE_KEY = 'services-bulk-selection';

export const readBulkSelection = (): SelectedServiceRef[] => {
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY);
		if (!raw) return [];
		const parsed = JSON.parse(raw) as SelectedServiceRef[];
		return Array.isArray(parsed) ? parsed : [];
	} catch {
		return [];
	}
};

export const saveBulkSelection = (selection: SelectedServiceRef[]): void => {
	if (!selection.length) {
		sessionStorage.removeItem(STORAGE_KEY);
		return;
	}
	sessionStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
};

export const getSelectionHomogeneity = (
	selection: SelectedServiceRef[],
): {
	isHomogeneous: boolean;
	serviceType: TypeServiceEnum | null;
	saleOrderCount: number;
	agencyCount: number;
	singleAgencyId: number | undefined;
} => {
	if (!selection.length) {
		return { isHomogeneous: false, serviceType: null, saleOrderCount: 0, agencyCount: 0, singleAgencyId: undefined };
	}

	const types = new Set(selection.map((item) => item.serviceType));
	const saleOrderIds = new Set(selection.map((item) => item.saleOrderId));
	const agencyIds = new Set(selection.map((item) => item.agencyId).filter((id): id is number => id !== undefined));

	return {
		isHomogeneous: types.size === 1,
		serviceType: types.size === 1 ? selection[0].serviceType : null,
		saleOrderCount: saleOrderIds.size,
		agencyCount: agencyIds.size,
		singleAgencyId: agencyIds.size === 1 ? [...agencyIds][0] : undefined,
	};
};

export const selectionKey = (item: SelectedServiceRef): string => item.serviceId;
